module.exports = __webpack_public_path__ + "static/media/081.f60139d0.jpg";